import PromisedResource from './PromisedResource'
import { InitializedRecord } from '@orbit/records'
import { getRecordIdentity } from 'lib/DataModel'

export default class ContractsResource extends PromisedResource<InitializedRecord> {
  constructor({remote, id}) {
    super(remote.query(q => q.findRecord(getRecordIdentity('contract', id))))
  }
}
